module.exports = __webpack_public_path__ + "img/logo_voice.b12520d6.png";